import { combineReducers } from "@reduxjs/toolkit";

import {
	customersClientsDataModalState,
	customersClientsDataModalReducer,
	customersClientsDataModalAction,
} from "./dataModal";

export type StateClients = {
	dataModal: customersClientsDataModalState;
};

export const clients = combineReducers<StateClients>({
	dataModal: customersClientsDataModalReducer,
});

export const clientsAction = {
	dataModal: customersClientsDataModalAction,
};

export default clients;
